import React from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SplashScreen from './components/SplashScreen';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedDataRoute from './components/ProtectedDataRoute';
import Landing from './pages/Landing';
import Signin from './pages/Signin';
import AdminSignIn from './pages/AdminSignIn';
import DataSignIn from './pages/DataSignIn';
import Dashboard from './pages/Dashboard';
import Device from './pages/Device';
import Overview from './pages/Overview';
import Maps from './pages/Maps';
import Groups from './pages/Groups';
import GroupDetails from './pages/GroupDetails';
import Presets from './pages/Presets';
import PresetDetails from './pages/PresetDetails';
import Schedules from './pages/Schedules';
import CalendarSchedules from './pages/CalendarSchedules';
import Traffic from './pages/Traffic';
import NotFound from './pages/NotFound';
import Unauthorized from './pages/Unauthorized';
import Settings from './pages/Settings';
import Help from './pages/Help';
import FileManagement from './pages/FileManagement';
import FileManagementDevice from './pages/FileManagementDevice';
import DataDashboard from './pages/DataDashboard';

import AdminRoute from './components/AdminRoute';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminMedia from './pages/admin/AdminMedia';
import AdminSetup from './pages/admin/AdminSetup';
import AdminDevice from './pages/admin/AdminDevice';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPackages from './pages/admin/AdminPackages';
import AdminEmail from './pages/admin/AdminEmail';
import AdminMap from './pages/admin/AdminMap';
import AdminDatabase from './pages/admin/AdminDatabase';
import AdminInspectionReg from './pages/admin/AdminInspectionReg';
import AdminInspection from './pages/admin/AdminInspection';
import InspectionSignIn from './pages/InspectionSignIn';
import UserInspection from './pages/UserInspection';
import ProtectedInspectionRoute from './components/ProtectedInspectionRoute';

import PublicRoute from './components/PublicRoute';
import Home from './pages/Home';
import Features from './pages/Features';
import Products from './pages/Products';
import RGBP5 from './pages/RGBP5';
import RGBP10 from './pages/RGBP10';
import RGP10 from './pages/RGP10';
import ServicePlan from './pages/ServicePlan';
import ContactUs from './pages/ContactUs';

const App = () => {
  return (
    <Router>
      <SplashScreen />
      <Routes>
        {/* Public Routes */}
        <Route path="/landing" element={<Landing />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/admin/signin" element={<AdminSignIn />} />
        <Route path="/data-signin" element={<DataSignIn />} />
        <Route path="/inspection-signin" element={<InspectionSignIn />} />

        <Route 
          path="/" 
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          } 
        />

        <Route 
          path="/features" 
          element={
            <PublicRoute>
              <Features />
            </PublicRoute>
          } 
        />

        <Route 
          path="/products" 
          element={
            <PublicRoute>
              <Products />
            </PublicRoute>
          } 
        />

        <Route 
          path="/products/rgbp5" 
          element={
            <PublicRoute>
              <RGBP5 />
            </PublicRoute>
          } 
        />

        
        <Route 
          path="/products/rgbp10" 
          element={
            <PublicRoute>
              <RGBP10 />
            </PublicRoute>
          } 
        />

        
        <Route 
          path="/products/rgp10" 
          element={
            <PublicRoute>
              <RGP10 />
            </PublicRoute>
          } 
        />

        
        <Route 
          path="/service-plans" 
          element={
            <PublicRoute>
              <ServicePlan />
            </PublicRoute>
          } 
        />

        
        <Route 
          path="/contact-us" 
          element={
            <PublicRoute>
              <ContactUs />
            </PublicRoute>
          } 
        />

        {/* Protected Routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/data/dashboard" 
          element={
            <ProtectedDataRoute>
              <DataDashboard />
            </ProtectedDataRoute>
          } 
        />

        <Route 
          path="/overview" 
          element={
            <ProtectedRoute>
              <Overview />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/maps" 
          element={
            <ProtectedRoute>
              <Maps />
            </ProtectedRoute>
          } 
        /> 

        <Route 
          path="/groups" 
          element={
            <ProtectedRoute>
              <Groups />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/groups/:groupId" 
          element={
            <ProtectedRoute>
              <GroupDetails />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/presets" 
          element={
            <ProtectedRoute>
              <Presets />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/presets/:presetId"d 
          element={
            <ProtectedRoute>
              <PresetDetails />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/schedules" 
          element={
            <ProtectedRoute>
              <Schedules />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/calendar-schedules" 
          element={
            <ProtectedRoute>
              <CalendarSchedules />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/traffic" 
          element={
            <ProtectedRoute>
              <Traffic />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/file-management" 
          element={
            <ProtectedRoute>
              <FileManagement />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/file-management/:deviceId" 
          element={
            <ProtectedRoute>
              <FileManagementDevice />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/device/:deviceId" 
          element={
            <ProtectedRoute>
              <Device />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/settings" 
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/help" 
          element={
            <ProtectedRoute>
              <Help />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin/dashboard" 
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/device/:deviceId" 
          element={
            <AdminRoute>
              <AdminDevice />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/setup" 
          element={
            <AdminRoute>
              <AdminSetup />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/media" 
          element={
            <AdminRoute>
              <AdminMedia />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/users" 
          element={
            <AdminRoute>
              <AdminUsers />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/packages" 
          element={
            <AdminRoute>
              <AdminPackages />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/email" 
          element={
            <AdminRoute>
              <AdminEmail />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/maps" 
          element={
            <AdminRoute>
              <AdminMap />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/database" 
          element={
            <AdminRoute>
              <AdminDatabase />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/inspection-registration" 
          element={
            <AdminRoute>
              <AdminInspectionReg />
            </AdminRoute>
          } 
        />

        <Route 
          path="/admin/inspection" 
          element={
            <AdminRoute>
              <AdminInspection />
            </AdminRoute>
          } 
        />

        <Route
          path="/inspection"
          element={
            <ProtectedInspectionRoute>
              <UserInspection />
            </ProtectedInspectionRoute>
          }
        />

        {/* Unauthorized Access Route */}
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Not Found Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
